define('collections/customer_notes',['require','collections/base','models/customer_note'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/customer_note");

    return BaseCollection.extend({
        model: Model,
        url: 'customer-notes.json'
    });
});

